import {
  TextInput,
  PasswordInput,
  BooleanInput,
  email,
  SimpleForm,
  Toolbar,
  SaveButton,
  DeleteWithConfirmButton,
  useRecordContext,
  useGetIdentity
} from "react-admin"
import { Grid, Typography, Box } from "@mui/material"

const UserToolbar = ({formType}) => {
  const { identity } = useGetIdentity();
  const record = useRecordContext();

  return (
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        {/* 儲存按鈕 (始終顯示) */}
        <SaveButton />
        {/*
          條件渲染刪除按鈕：
          1. 只在編輯模式顯示 (formType === "edit")
          2. 且當前登入者不能刪除自己 (identity.id !== recordId)
        */}
        { formType === "edit" && record?.id && identity.id !== record?.id && (
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此帳號嗎？"
          />
        )}
      </Box>
    </Toolbar>
  );
};

const validateForm = values => {
  const errors = {}
  if (!values.name) {
    errors.name = "ra.validation.required"
  }
  if (!values.account) {
    errors.account = "ra.validation.required"
  }
  if (!values.email) {
    errors.email = "ra.validation.required"
  } else {
    const error = email()(values.email)
    if (error) {
      errors.email = error
    }
  }
  // 密碼規則：英文與數字組合，8-12 字元
  if (values.password) {
    const password = values.password
    const lengthValid = password.length >= 8 && password.length <= 12
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasNumber = /\d/.test(password)

    if (!lengthValid || !hasLetter || !hasNumber) {
      errors.password = "resources.users.errors.password_invalid"
    }

    if (password !== values.confirm_password) {
      errors.confirm_password = "resources.users.errors.password_mismatch"
    }
  }
  return errors
}

const UserForm = ({formType}) => (
  <SimpleForm
    defaultValues={{
      name: "",
      email: "",
      account: "",
      password: "",
      confirm_password: "",
      status: true,
    }}
    validate={validateForm}
    toolbar={<UserToolbar formType={formType} />}
  >
    <Grid container width={{ xs: "80%", xl: 800 }} spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom >
          基本資料
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextInput autoFocus source="name" label="名稱" isRequired />
      </Grid>
      <Grid item xs={12}>
        <TextInput type="email" source="email" label="Email" autoComplete="email" isRequired />
      </Grid>
      <Grid item xs={12}>
        <TextInput source="account" label="帳號" isRequired />
      </Grid>
      <Grid item xs={12}>
        <BooleanInput label="啟用狀態" source="status" />
      </Grid>
      <Grid item xs={12}>
        <TextInput 
          source="note" 
          label="備註" 
          rows={4} 
          multiline
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom >
          密碼
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <PasswordInput 
          source="password" 
          label="密碼"
          helperText="密碼需為 8-12 字元，且包含英文與數字"
          autoComplete="password"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <PasswordInput 
          source="confirm_password" 
          label="再次輸入密碼" 
          autoComplete="confirm_password"
        />
      </Grid>
    </Grid>
  </SimpleForm>
)

export default UserForm